"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureHoneycombHttpJsonTraceExporter = exports.DATASET_HEADER_KEY = exports.TEAM_HEADER_KEY = void 0;
const exporter_trace_otlp_http_1 = require("@opentelemetry/exporter-trace-otlp-http");
const util_1 = require("./util");
exports.TEAM_HEADER_KEY = 'x-honeycomb-team';
exports.DATASET_HEADER_KEY = 'x-honeycomb-dataset';
/**
 * Builds and returns an OTLP Traces exporter that sends data over http/json
 * @param options The {@link HoneycombOptions} used to configure the exporter
 * @returns a {@link SpanExporter} configured to send telemetry to Honeycomb over http/json
 */
function configureHoneycombHttpJsonTraceExporter(options) {
    const apiKey = (0, util_1.getTracesApiKey)(options);
    return new exporter_trace_otlp_http_1.OTLPTraceExporter({
        url: (0, util_1.getTracesEndpoint)(options),
        headers: {
            [exports.TEAM_HEADER_KEY]: apiKey,
            [exports.DATASET_HEADER_KEY]: (0, util_1.isClassic)(apiKey) ? options === null || options === void 0 ? void 0 : options.dataset : undefined,
        },
    });
}
exports.configureHoneycombHttpJsonTraceExporter = configureHoneycombHttpJsonTraceExporter;
